import { IDimensionalityOption } from 'constants/businessTool';

import { IPeriodsTableRow, IPeriodsTableRows } from 'components/BusinessToolForm/constants/periods';
import {
  PRODUCTION_NAMES,
  prefix as productionPrefix,
} from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/utils/form';
import { CALENDAR_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/CalendarPlanForm/utils/form';
import { FUNDING_DIRECTIONS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/FundingDirectionsForm/utils/form';
import { LOAN_REPAYMENT_SCHEDULE_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/LoanRepaymentScheduleForm/utils/form';
import {
  calendarPlanPrefix,
  fundingDirectionsPrefix,
  loanRepaymentSchedulePrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/utils/form';
import { EFFICIENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/EfficiencyForm/utils/form';
import {
  INVESTMENT_FORM_NAMES,
  INVESTMENT_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/InvestmentForm/utils/form';
import { LIQUIDITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/LiquidityForm/utils/form';
import { PROFITABILITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/ProfitabilityForm/utils/form';
import { SOLVENCY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/SolvencyForm/utils/form';
import {
  efficiencyFormPrefix,
  investmentFormPrefix,
  liquidityFormPrefix,
  profitabilityFormPrefix,
  solvencyFormPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/utils/form';
import {
  CURRENT_ASSETS_NAMES,
  INITIAL_ASSETS_NAMES,
  NON_CURRENT_ASSETS_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialAssetsForm/utils/form';
import { EQUITY_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialEquityForm/utils/form';
import {
  CURRENT_LIABILITIES_NAMES,
  INITIAL_LIABILITIES_NAMES,
  NON_CURRENT_LIABILITIES_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialLiabilitiesForm/utils/form';
import {
  initialAssetsFormPrefix,
  initialEquityFormPrefix,
  initialLiabilitiesFormPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/utils/form';
import { COST_OF_EACH_UNIT_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfEachUnitForm/utils/form';
import {
  COST_OF_SALES_FORM_NAMES,
  IRow,
} from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfSalesForm/utils/form';
import { GENERAL_AND_ADMINISTRATIVE_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/GeneralAndAdministrativeForm/utils/form';
import { monthlyExpansesFormType } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/MonthlyExpensesForm/utils/form';
import { PERSONNEL_EXPENSES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/PersonnelExpensesForm/utils/form';
import { R_AND_D_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/RAndDForm/utils/form';
import { SALES_AND_MARKETING_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/SalesAndMarketingForm/utils/form';
import { TOTAL_EXPENSES_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/TotalExpensesForm/utils/form';
import {
  costOfEachUnitPrefix,
  costOfSalesPrefix,
  generalAndAdministrativePrefix,
  monthlyExpensesPrefix,
  personnelExpensesPrefix,
  rAndDPrefix,
  salesAndMarketingPrefix,
  totalExpensesPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/utils/form';
import { NET_INCOME_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetIncome/utils/form';
import { NET_SALES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetSalesForm/utils/form';
import { OPERATING_EXPENSES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/OperatingExpensesForm/utils/form';
import {
  netIncomePrefix,
  netSalesPrefix,
  operatingExpensesPrefix,
  PROFIT_AND_LOSS_PROJECTION_FORM_NAMES,
  prefix as profitAndLossPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/utils/form';
import {
  ASSETS_FORM_NAMES,
  CURRENT_ASSETS_TABLE_TOTAL_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/Sections/Assets/utils/form';
import {
  CURRENT_LIABILITIES_TABLE_NAMES,
  EQUITY_TABLE_NAMES,
  LIABILITIES_AND_EQUITY_FORM_NAMES,
  NON_CURRENT_LIABILITIES_TABLE_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/Sections/LiabilitiesAndEquity/utils/form';
import {
  assetsPrefix,
  liabilitiesAndEquityPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/utils/form';
import { TOTAL_FIELDS } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/DirectFormTable/utils/form';
import { FINANCING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/FinancingActivities/utils/form';
import { INVESTING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/InvestingActivities/utils/form';
import { OPERATING_ACTIVITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/DirectForm/DirectFormComponents/Sections/OperatingActivities/utils/form';
import { INDIRECT_TOTAL_FIELDS } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/InDirectForm/InDirectFormComponents/InDirectFormTable/utils/form';
import { ADJUSTMENTS_FOR_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/InDirectForm/InDirectFormComponents/Sections/AdjustmentsForForm/utils/form';
import { OPERATING_ASSETS_AND_LIABILITIES_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/InDirectForm/InDirectFormComponents/Sections/OperatingAssetsAndLiabilitiesForm/utils/form';
import { OTHER_ITEMS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/InDirectForm/InDirectFormComponents/Sections/OtherItemsForm/utils/form';
import {
  adjustmentsForPrefix,
  directFormPrefix,
  financingActivitiesPrefix,
  inDirectFormPrefix,
  investingActivitiesPrefix,
  operatingActivitiesPrefix,
  operatingAssetsAndLiabilitiesPrefix,
  otherItemsPrefix,
  PROJECTED_CASH_FLOW_FORM_NAMES,
  projectedCashFlowPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedCashFlow/utils/form';
import {
  REVENUE_PLAN_NAMES,
  prefix as revenuePlanPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/RevenuePlan/utils/form';
import { GLOBAL_PRODUCTS_NAME, GLOBAL_UNIT_NAME } from 'components/BusinessToolForm/Sections/Global/form';
import { IGlobalProductEntity } from 'components/BusinessToolForm/Sections/Global/general/products';
import {
  prefix as marketingAndSalesPrefix,
  SALES_NAMES,
} from 'components/BusinessToolForm/Sections/MarketingAndSales/SalesPlanSection/utils/form';

import { concatWithDot } from 'helpers/string';
import { ObjectValues } from 'helpers/types';

export interface ICalculateFields {
  observeValueChangeFieldNames: string[];
  setCalculatedValueFieldNames: string[];
}
export const OBSERVED_FORMS = {
  SALES_PLAN: 'salesPlan',
  REVENUE_PLAN: 'revenuePlan',
  PROFIT_AND_LOSS: 'profitAndLoss',
  EXPENSES_MONTHLY: 'expensesMonthly',
  PERSONAL_EXPENSES_BY_CATEGORY: 'personalExpensesByCategory',
  CASH_FLOW_FROM_CUSTOMERS: 'cashFlowFromCustomers',
  CASH_FLOW_TO_SUPPLIERS: 'cashFlowToSuppliers',
  OPERATING_ACTIVITIES_NET_CASH: 'operatingActivitiesNetCash',
  FINANCIAL_ACTIVITIES_NET_CASH: 'financialActivitiesNetCash',
  INVESTING_ACTIVITIES_NET_CASH: 'investingActivitiesNetCash',
  TOTAL_NET_CASH: 'totalDirectNetCash',
  PRODUCTION: 'production',
  CURRENT_ASSETS_TOTAL: 'currentAssetsTotal',
  NON_CURRENT_ASSETS_TOTAL: 'nonCurrentAssetsTotal',
  CURRENT_LIABILITIES_TOTAL: 'currentLiabilitiesTotal',
  NON_CURRENT_LIABILITIES_TOTAL: 'nonCurrentLiabilitiesTotal',
  EQUITY_TOTAL: 'equityTotal',
  TOTAL_ASSETS: 'totalAssets',
  TOTAL_LIABILITIES_EQUITY: 'totalLiabilitiesEquity',
  PPE_ASSETS: 'ppeAssets',
  LONG_TERM_INVESTMENTS: 'longTermInvestments',
  LONG_TERM_DEBT: 'longTermDebt',
  COMMON_STOCK: 'commonStock',
  RETAINED_EARNINGS: 'retainedEarnings',
  PERFORMANCE_SOLVENCY: 'performanceSolvency',
  PERFORMANCE_PROFITABILITY: 'performanceProfitability',
  PERFORMANCE_LIQUIDITY: 'performanceLiquidity',
  PERFORMANCE_INVESTMENT: 'performanceInvestment',
  PERFORMANCE_EFFICIENCY: 'performanceEfficiency',
  SELLING_ASSETS: 'sellingAssets',
  DEFERRED_TAX_CHANGES: 'deferredTaxChanges',
  CASH_FLOW_LIABILITIES: 'cashFlowLiabilities',
  TOTAL_INDIRECT_NET_CASH: 'totalIndirectNetCash',
  CURRENT_UNIT: 'currentUnit',
  OTHER_NON_CURRENT_ASSETS: 'otherNonCurrentAssets',
} as const;

export type IObservedFormsType = ObjectValues<typeof OBSERVED_FORMS>;

export type IObservedFieldsType = Record<IObservedFormsType, ICalculateFields>;

export const observedFields: IObservedFieldsType = {
  salesPlan: {
    observeValueChangeFieldNames: [
      GLOBAL_PRODUCTS_NAME,
      GLOBAL_UNIT_NAME,
      concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(marketingAndSalesPrefix, SALES_NAMES.PLANNED_PRODUCTS_VOLUME),
      concatWithDot(marketingAndSalesPrefix, SALES_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
    ],
  },
  revenuePlan: {
    observeValueChangeFieldNames: [
      GLOBAL_PRODUCTS_NAME,
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_OTHER_INCOME),
      GLOBAL_UNIT_NAME,
      concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME),
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
    ],
  },
  profitAndLoss: {
    observeValueChangeFieldNames: [
      GLOBAL_UNIT_NAME,
      concatWithDot(profitAndLossPrefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.FINANCIAL_INCOME),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE_TOTAL),
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(netSalesPrefix, NET_SALES_NAMES.GROSS_PROFIT),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.INCOME_TAX),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NET_INCOME),
      concatWithDot(operatingExpensesPrefix, OPERATING_EXPENSES_NAMES.TOTAL_OPERATING_EXPENSES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID),
      concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL),
      concatWithDot(inDirectFormPrefix, INDIRECT_TOTAL_FIELDS.NET_INCOME_PROFIT_FOR_PERIOD.name),
      concatWithDot(otherItemsPrefix, OTHER_ITEMS_NAMES.INCOME_TAXES_PAID),
    ],
  },
  expensesMonthly: {
    observeValueChangeFieldNames: [
      monthlyExpensesPrefix,
      GLOBAL_UNIT_NAME,
      GLOBAL_PRODUCTS_NAME,
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE),
      concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE_TOTAL),
      concatWithDot(netSalesPrefix, NET_SALES_NAMES.COST_OF_SALES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INTEREST_PAID),
      concatWithDot(loanRepaymentSchedulePrefix, LOAN_REPAYMENT_SCHEDULE_NAMES.TABLE),
      // TODO delete if client agreed
      // concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS),
      concatWithDot(operatingExpensesPrefix, OPERATING_EXPENSES_NAMES.R_AND_D),
      concatWithDot(operatingExpensesPrefix, OPERATING_EXPENSES_NAMES.SALES_AND_MARKETING),
      concatWithDot(operatingExpensesPrefix, OPERATING_EXPENSES_NAMES.GENERAL_AND_ADMINISTRATIVE),
      concatWithDot(operatingExpensesPrefix, OPERATING_EXPENSES_NAMES.OTHER_OPERATING_EXPENSES),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.FINANCIAL_EXPENSES),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NON_OPERATING_EXPENSES),
      concatWithDot(otherItemsPrefix, OTHER_ITEMS_NAMES.INTEREST_PAID),
    ],
  },
  personalExpensesByCategory: {
    observeValueChangeFieldNames: [
      GLOBAL_UNIT_NAME,
      concatWithDot(costOfSalesPrefix, COST_OF_SALES_FORM_NAMES.COST_OF_SALES_TABLE),
      concatWithDot(rAndDPrefix, R_AND_D_FORM_NAMES.R_AND_D_TABLE),
      concatWithDot(salesAndMarketingPrefix, SALES_AND_MARKETING_FORM_NAMES.SALES_AND_MARKETING_TABLE),
      concatWithDot(
        generalAndAdministrativePrefix,
        GENERAL_AND_ADMINISTRATIVE_FORM_NAMES.GENERAL_AND_ADMINISTRATIVE_TABLE,
      ),
      concatWithDot(costOfEachUnitPrefix, COST_OF_EACH_UNIT_FORM_NAMES.COST_OF_EACH_UNIT_TABLE),
      GLOBAL_PRODUCTS_NAME,
      concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME),
      concatWithDot(personnelExpensesPrefix, PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TABLE),
      concatWithDot(personnelExpensesPrefix, PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TOTAL),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(personnelExpensesPrefix, PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TABLE),
      concatWithDot(personnelExpensesPrefix, PERSONNEL_EXPENSES_FORM_NAMES.PERSONNEL_EXPENSES_TOTAL),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES),
    ],
  },
  cashFlowFromCustomers: {
    observeValueChangeFieldNames: [
      GLOBAL_UNIT_NAME,
      concatWithDot(
        concatWithDot(
          initialAssetsFormPrefix,
          INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
          CURRENT_ASSETS_NAMES.CREDIT_SALES_PAYMENT_DURATION,
        ),
      ),
      concatWithDot(
        concatWithDot(
          initialAssetsFormPrefix,
          INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
          CURRENT_ASSETS_NAMES.PERCENT_CREDIT_SALES,
        ),
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
        CURRENT_ASSETS_NAMES.ACCOUNTS_RECEIVABLE,
      ),
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS),
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
        CURRENT_ASSETS_TABLE_TOTAL_NAMES.ACCOUNTS_RECEIVABLE,
      ),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE,
      ),
    ],
  },
  cashFlowToSuppliers: {
    observeValueChangeFieldNames: [
      GLOBAL_UNIT_NAME,
      concatWithDot(
        concatWithDot(
          initialLiabilitiesFormPrefix,
          INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
          CURRENT_LIABILITIES_NAMES.PAYMENT_DURATION_CREDIT_PURCHASES,
        ),
      ),
      concatWithDot(
        concatWithDot(
          initialLiabilitiesFormPrefix,
          INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
          CURRENT_LIABILITIES_NAMES.PERCENT_CREDIT_PURCHASES,
        ),
      ),
      concatWithDot(
        concatWithDot(
          initialAssetsFormPrefix,
          INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
          CURRENT_ASSETS_NAMES.INVENTORY_VALUE,
        ),
      ),
      concatWithDot(
        concatWithDot(
          initialAssetsFormPrefix,
          INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
          CURRENT_ASSETS_NAMES.INVENTORY_SIZE_AVG_MONTHLY_INCOME,
        ),
      ),
      concatWithDot(netSalesPrefix, NET_SALES_NAMES.COST_OF_SALES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES),
      concatWithDot(costOfSalesPrefix, COST_OF_SALES_FORM_NAMES.COST_OF_SALES_TABLE),
      concatWithDot(salesAndMarketingPrefix, SALES_AND_MARKETING_FORM_NAMES.SALES_AND_MARKETING_TABLE),
      concatWithDot(
        generalAndAdministrativePrefix,
        GENERAL_AND_ADMINISTRATIVE_FORM_NAMES.GENERAL_AND_ADMINISTRATIVE_TABLE,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.TOTAL_ACCOUNTS_PAYABLE,
      ),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NON_OPERATING_EXPENSES),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE, CURRENT_ASSETS_TABLE_TOTAL_NAMES.INVENTORY),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.ACCOUNTS_PAYABLE,
      ),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES,
      ),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE,
      ),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.DEPRECATION),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.AMORTIZATIONS),
    ],
  },
  operatingActivitiesNetCash: {
    observeValueChangeFieldNames: [
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INTEREST_PAID),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES),
    ],
  },
  financialActivitiesNetCash: {
    observeValueChangeFieldNames: [
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.TABLE),
    ],
    setCalculatedValueFieldNames: [concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.TOTAL)],
  },
  investingActivitiesNetCash: {
    observeValueChangeFieldNames: [
      // TODO delete if client agreed
      // concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.LOSS_ON_SALE_OF_ASSETS),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
    ],
    setCalculatedValueFieldNames: [concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TOTAL)],
  },
  totalDirectNetCash: {
    observeValueChangeFieldNames: [
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.TOTAL),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TOTAL),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
        CURRENT_ASSETS_NAMES.CASH_EQUIVALENTS,
      ),
      concatWithDot(inDirectFormPrefix, INDIRECT_TOTAL_FIELDS.NET_CASH_PROVIDED_OPERATING_ACTIVITIES.name),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.SELECTED_TYPE),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(directFormPrefix, TOTAL_FIELDS.NET_INCREASE_DECREASE_CASH_EQUIVALENTS.name),
      concatWithDot(directFormPrefix, TOTAL_FIELDS.CASH_EQUIVALENTS_BEGINNING_PERIOD.name),
      concatWithDot(directFormPrefix, TOTAL_FIELDS.CASH_EQUIVALENTS_END_PERIOD.name),
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
        CURRENT_ASSETS_TABLE_TOTAL_NAMES.CASH_EQUIVALENTS,
      ),
    ],
  },
  production: {
    observeValueChangeFieldNames: [GLOBAL_PRODUCTS_NAME, GLOBAL_UNIT_NAME],
    setCalculatedValueFieldNames: [concatWithDot(productionPrefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME)],
  },
  currentAssetsTotal: {
    observeValueChangeFieldNames: [concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE)],
    setCalculatedValueFieldNames: [concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE_TOTAL)],
  },
  nonCurrentAssetsTotal: {
    observeValueChangeFieldNames: [concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE)],
    setCalculatedValueFieldNames: [concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE_TOTAL)],
  },
  currentLiabilitiesTotal: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE_TOTAL),
    ],
  },
  nonCurrentLiabilitiesTotal: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE_TOTAL),
    ],
  },
  equityTotal: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE_TOTAL),
    ],
  },
  totalAssets: {
    observeValueChangeFieldNames: [
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE_TOTAL),
    ],
    setCalculatedValueFieldNames: [concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.TOTAL_ASSETS)],
  },
  totalLiabilitiesEquity: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE_TOTAL),
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE_TOTAL),
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE_TOTAL),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.TOTAL_LIABILITIES_AND_EQUITY),
    ],
  },
  ppeAssets: {
    observeValueChangeFieldNames: [
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.INITIAL_COST_PPE,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.INTANGIBLE_ASSETS,
      ),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.DEPRECATION),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.AMORTIZATIONS),
      concatWithDot(fundingDirectionsPrefix, FUNDING_DIRECTIONS_NAMES.TABLE),
      GLOBAL_UNIT_NAME,
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
        NON_CURRENT_ASSETS_NAMES.INITIAL_COST_PPE,
      ),
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
        NON_CURRENT_ASSETS_NAMES.INTANGIBLE_ASSETS,
      ),
    ],
  },
  longTermInvestments: {
    observeValueChangeFieldNames: [
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.LONG_TERM_INVESTMENTS,
      ),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
        NON_CURRENT_ASSETS_NAMES.LONG_TERM_INVESTMENTS,
      ),
    ],
  },
  longTermDebt: {
    observeValueChangeFieldNames: [
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.NON_CURRENT_LIABILITIES,
        NON_CURRENT_LIABILITIES_NAMES.TOTAL_LONG_TERM_DEBT,
      ),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
        NON_CURRENT_LIABILITIES_TABLE_NAMES.LONG_TERM_DEBT,
      ),
    ],
  },
  commonStock: {
    observeValueChangeFieldNames: [
      concatWithDot(initialEquityFormPrefix, EQUITY_NAMES.TOTAL_STOCKHOLDERS_EQUITY),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.TABLE),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE,
        EQUITY_TABLE_NAMES.OWNERS_EQUITY,
      ),
    ],
  },
  otherNonCurrentAssets: {
    observeValueChangeFieldNames: [
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.OTHER_NON_CURRENT_ASSETS,
      ),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
        NON_CURRENT_ASSETS_NAMES.OTHER_NON_CURRENT_ASSETS,
      ),
    ],
  },
  retainedEarnings: {
    observeValueChangeFieldNames: [
      concatWithDot(initialEquityFormPrefix, EQUITY_NAMES.RETAINED_EARNINGS),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NET_INCOME),
      concatWithDot(financingActivitiesPrefix, FINANCING_ACTIVITIES_NAMES.TABLE),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE,
        EQUITY_TABLE_NAMES.RETAINED_EARNINGS,
      ),
    ],
  },
  performanceSolvency: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE_TOTAL),
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE_TOTAL),
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.TOTAL_ASSETS),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION),
      concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INTEREST_PAID),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [concatWithDot(solvencyFormPrefix, SOLVENCY_FORM_NAMES.SOLVENCY_TABLE)],
  },
  performanceProfitability: {
    observeValueChangeFieldNames: [
      concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.INCOME_TAX),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.INTEREST_PAID),
      GLOBAL_UNIT_NAME,
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
      concatWithDot(netSalesPrefix, NET_SALES_NAMES.GROSS_PROFIT),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NET_INCOME),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TABLE),
    ],
  },
  performanceLiquidity: {
    observeValueChangeFieldNames: [
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.TOTAL_ASSETS),
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE, CURRENT_ASSETS_TABLE_TOTAL_NAMES.INVENTORY),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [concatWithDot(liquidityFormPrefix, LIQUIDITY_FORM_NAMES.LIQUIDITY_TABLE)],
  },
  performanceInvestment: {
    observeValueChangeFieldNames: [
      concatWithDot(liabilitiesAndEquityPrefix, LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.TOTAL_ASSETS),
      concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.DISCOUNT_RATE),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NET_INCOME),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.PURCHASE_PROPERTY_PLANT_EQUIPMENT),
      concatWithDot(investingActivitiesPrefix, INVESTING_ACTIVITIES_NAMES.TABLE),
      concatWithDot(operatingActivitiesPrefix, OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES),
      concatWithDot(calendarPlanPrefix, CALENDAR_PLAN_NAMES.TOTAL),
      concatWithDot(inDirectFormPrefix, INDIRECT_TOTAL_FIELDS.NET_CASH_PROVIDED_OPERATING_ACTIVITIES.name),
      concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.SELECTED_TYPE),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        investmentFormPrefix,
        INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
        INVESTMENT_ROW_NAMES.RETURN_ON_INVESTMENT,
      ),
      concatWithDot(
        investmentFormPrefix,
        INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
        INVESTMENT_ROW_NAMES.RETURN_ON_EQUITY,
      ),
      concatWithDot(
        investmentFormPrefix,
        INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
        INVESTMENT_ROW_NAMES.RETURN_ON_ASSETS,
      ),
      concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.INVESTMENT_TABLE, INVESTMENT_ROW_NAMES.RATE_OF_RETURN),
      concatWithDot(
        investmentFormPrefix,
        INVESTMENT_FORM_NAMES.INVESTMENT_TABLE,
        INVESTMENT_ROW_NAMES.NET_PRESENT_VALUE,
      ),
      concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.INVESTMENT_TABLE, INVESTMENT_ROW_NAMES.PAYBACK_PERIOD),
    ],
  },
  performanceEfficiency: {
    observeValueChangeFieldNames: [
      concatWithDot(initialAssetsFormPrefix, INITIAL_ASSETS_NAMES.CURRENT_ASSETS, CURRENT_ASSETS_NAMES.INVENTORY_VALUE),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
        CURRENT_ASSETS_NAMES.ACCOUNTS_RECEIVABLE,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.TOTAL_ACCOUNTS_PAYABLE,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.INTANGIBLE_ASSETS,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.INITIAL_COST_PPE,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.RIGHT_OF_USE_ASSETS,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.GOODWILL,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.LONG_TERM_INVESTMENTS,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.DEFERRED_TAX_ASSETS,
      ),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.OTHER_NON_CURRENT_ASSETS,
      ),
      concatWithDot(netSalesPrefix, NET_SALES_NAMES.COST_OF_SALES),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE, CURRENT_ASSETS_TABLE_TOTAL_NAMES.INVENTORY),
      concatWithDot(revenuePlanPrefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE_TOTAL),
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
        CURRENT_ASSETS_TABLE_TOTAL_NAMES.ACCOUNTS_RECEIVABLE,
      ),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.ACCOUNTS_PAYABLE,
      ),
      GLOBAL_UNIT_NAME,
    ],
    setCalculatedValueFieldNames: [concatWithDot(efficiencyFormPrefix, EFFICIENCY_FORM_NAMES.EFFICIENCY_TABLE)],
  },
  sellingAssets: {
    observeValueChangeFieldNames: [
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NON_OPERATING_INCOME),
      concatWithDot(netIncomePrefix, NET_INCOME_NAMES.NON_OPERATING_EXPENSES),
    ],
    setCalculatedValueFieldNames: [concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES)],
  },
  deferredTaxChanges: {
    observeValueChangeFieldNames: [
      concatWithDot(
        assetsPrefix,
        ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
        NON_CURRENT_ASSETS_NAMES.DEFERRED_TAX_ASSETS,
      ),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES),
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS,
        NON_CURRENT_ASSETS_NAMES.DEFERRED_TAX_ASSETS,
      ),
    ],
  },
  cashFlowLiabilities: {
    observeValueChangeFieldNames: [
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
        CURRENT_ASSETS_NAMES.PREPAID_EXPENSES,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.ACCRUED_LIABILITIES,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.TOTAL_DEFERRED_REVENUE,
      ),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE, CURRENT_ASSETS_NAMES.PREPAID_EXPENSES),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.ACCRUED_LIABILITIES,
      ),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_REVENUE,
      ),
      GLOBAL_UNIT_NAME,
      concatWithDot(
        initialAssetsFormPrefix,
        INITIAL_ASSETS_NAMES.CURRENT_ASSETS,
        CURRENT_ASSETS_NAMES.OTHER_CURRENT_ASSETS,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.DEFERRED_TAX_LIABILITIES,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.PROVISIONS,
      ),
      concatWithDot(
        initialLiabilitiesFormPrefix,
        INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES,
        CURRENT_LIABILITIES_NAMES.OTHER_CURRENT_LIABILITIES,
      ),
      concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE, CURRENT_ASSETS_NAMES.OTHER_CURRENT_ASSETS),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_TAX_LIABILITIES,
      ),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.PROVISIONS,
      ),
      concatWithDot(
        liabilitiesAndEquityPrefix,
        LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
        CURRENT_LIABILITIES_TABLE_NAMES.OTHER_CURRENT_LIABILITIES,
      ),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES,
      ),
    ],
  },
  totalIndirectNetCash: {
    observeValueChangeFieldNames: [
      concatWithDot(inDirectFormPrefix, INDIRECT_TOTAL_FIELDS.NET_INCOME_PROFIT_FOR_PERIOD.name),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES),
      concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE,
      ),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES,
      ),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE,
      ),
      concatWithDot(
        operatingAssetsAndLiabilitiesPrefix,
        OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES,
      ),
    ],
    setCalculatedValueFieldNames: [
      concatWithDot(inDirectFormPrefix, INDIRECT_TOTAL_FIELDS.NET_CASH_PROVIDED_OPERATING_ACTIVITIES.name),
    ],
  },
  currentUnit: {
    observeValueChangeFieldNames: [GLOBAL_UNIT_NAME],
    setCalculatedValueFieldNames: [],
  },
};
export interface IFormContentTypes {
  salesPlan: [IGlobalProductEntity[], IDimensionalityOption, IPeriodsTableRow[]];
  revenuePlan: [IGlobalProductEntity[], IPeriodsTableRow[], IDimensionalityOption, IPeriodsTableRow[]];
  profitAndLoss: [string, string, IPeriodsTableRow[], IPeriodsTableRows[]];
  expensesMonthly: [monthlyExpansesFormType, string, IGlobalProductEntity[], IPeriodsTableRows[]];
  personalExpensesByCategory: [
    IDimensionalityOption,
    IRow[],
    IRow[],
    IRow[],
    IRow[],
    IRow[],
    IGlobalProductEntity[],
    IPeriodsTableRow[],
    IRow[],
    IRow[],
  ];
  cashFlowFromCustomers: [IDimensionalityOption, string, number, number];
  cashFlowToSuppliers: [
    IDimensionalityOption,
    string,
    number,
    number,
    number,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IRow[],
    IRow[],
    IRow[],
    number,
    IPeriodsTableRow,
  ];
  operatingActivitiesNetCash: [
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
  ];
  financialActivitiesNetCash: [IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow[]];
  investingActivitiesNetCash: [IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow[]];
  totalDirectNetCash: [IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow, number, IPeriodsTableRow, string];
  production: [IGlobalProductEntity[], IDimensionalityOption];
  currentAssetsTotal: [IPeriodsTableRow[]];
  nonCurrentAssetsTotal: [IPeriodsTableRow[]];
  currentLiabilitiesTotal: [IPeriodsTableRow[]];
  nonCurrentLiabilitiesTotal: [IPeriodsTableRow[]];
  equityTotal: [IPeriodsTableRow[]];
  totalAssets: [IPeriodsTableRow[]];
  totalLiabilitiesEquity: [IPeriodsTableRow[]];
  ppeAssets: [
    string,
    string,
    IPeriodsTableRows[],
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow[],
    string,
    IPeriodsTableRows,
  ];
  longTermInvestments: [string, IPeriodsTableRow[], string];
  longTermDebt: [string, IPeriodsTableRow, IPeriodsTableRow, string];
  commonStock: [string, IPeriodsTableRow, IPeriodsTableRow[], string];
  retainedEarnings: [string, IPeriodsTableRow, IPeriodsTableRow[], string];
  performanceSolvency: [
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow[],
    IPeriodsTableRow,
    string,
  ];
  performanceProfitability: [
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    string,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
  ];
  performanceLiquidity: [IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow, IPeriodsTableRow, string];
  performanceInvestment: [
    IPeriodsTableRow,
    IPeriodsTableRow,
    string,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow[],
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    string,
    string,
  ];
  performanceEfficiency: [
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    string,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    string,
  ];
  sellingAssets: [IPeriodsTableRow[], IPeriodsTableRow];
  deferredTaxChanges: [IPeriodsTableRow];
  cashFlowLiabilities: [
    string,
    string,
    string,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    string,
    string,
    string,
    string,
    string,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
  ];
  totalIndirectNetCash: [
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
    IPeriodsTableRow,
  ];
  currentUnit: [IDimensionalityOption];
  otherNonCurrentAssets: [number, IPeriodsTableRow[], IDimensionalityOption];
}

export type IFormContentType<T extends keyof IFormContentTypes> = IFormContentTypes[T];

export const PRODUCT_CHANGE_TYPE = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE',
  NO_CHANGE: 'NO_CHANGE',
};

export type IProductChangeType = ObjectValues<typeof PRODUCT_CHANGE_TYPE>;
